import { IAnalyticsResponse } from '@adminPortal/_common/_interfaces/IAnalytics';
import { createActionGroup, props } from '@ngrx/store';

export const StatisticsActions = createActionGroup({
  source: 'Statistics',
  events: {
    'Load Statistics': props<{ startDate: string; endDate: string }>(),
    'Load Statistics Success': props<{ statistics: IAnalyticsResponse }>(),
    'Load Statistics Failure': props<{ error: any }>(),
  },
});
